/**
 * What kind of failure the worker reported, from the message it stored. The categories exist to
 * tell people what to do next: a missing photo is fixed in the tray, a dropped connection is fixed
 * by trying again, and only a genuinely unknown failure gets the shrug (docs/10-ux-audit.md · UX-31).
 */
export type ExportFailure = 'asset' | 'timeout' | 'connection' | 'renderer' | 'unknown';

export function classifyFailure(error: string | null): ExportFailure {
  const e = (error ?? '').toLowerCase();
  if (!e) return 'unknown';
  if (/nosuchkey|no such key|notfound|not found|enoent|missing (photo|object|asset|image)|404/.test(e)) return 'asset';
  if (/timeout|timed out|deadline|etimedout/.test(e)) return 'timeout';
  if (/econnrefused|econnreset|enotfound|socket hang up|network|fetch failed|502|503|504/.test(e)) return 'connection';
  if (/target closed|protocol error|crash|out of memory|oom|browser|chromium|page closed/.test(e)) return 'renderer';
  return 'unknown';
}
